import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Tools from "./JNSTools";
import { CredsContext } from "./Contexts";

import { grey } from "@mui/material/colors";

import "./styles/Settings.css";

function SettingsIssues() {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const settings = JSON.parse(localStorage.getItem("oadaSettings"));
  const [requiredDateEnabled, setRequiredDateEnabled] = useState(
    settings ? settings.requiredDateEnabled : false,
  );

  const handleRequiredDateEnabledClick = () => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const newSettings = {
      ...currentSettings,
      requiredDateEnabled: !requiredDateEnabled,
    };

    localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
    Tools.writeSettings(creds, projectObject.id);
    setRequiredDateEnabled(!requiredDateEnabled);
  };

  return (
    <Box>
      <FormControl>
        <FormLabel>
          <div className="settingsGroupTitle">Issues Settings</div>
        </FormLabel>
        <FormControlLabel
          checked={requiredDateEnabled}
          onClick={handleRequiredDateEnabledClick}
          control={
            <Checkbox
              size="small"
              sx={{
                color: grey[50],
                "&.Mui-checked": {
                  color: grey[50],
                },
              }}
            />
          }
          label="Show Resolution Required Date"
          className="settingsRadioButtonLabel"
        />
      </FormControl>
    </Box>
  );
}

export default SettingsIssues;

SettingsIssues.propTypes = {
  handleSettingsChange: PropTypes.func,
};
